export enum Action {
    None = 0,
    ChangeOrderType = 1,
    ChangePage = 2,
}